export enum PartnerBadge {
  PREMIER = 'Premier',
  AUTHORIZED = 'Authorized',
  ELITE = 'Elite',
}
